module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "middle-dialog",
    attrs: {
      "title": "审批进度",
      "width": "640px",
      "close-on-click-modal": false,
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.dialogVisible) ? _c('rt-approval-progress', {
    attrs: {
      "entity-name": _vm.entityName,
      "entity-id": _vm.entityId
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31a5ed98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/approval/src/progress-dialog.vue
// module id = 1484
// module chunks = 124